/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
.radio {
  display: inline-block;
  position: relative;
  width: calc(var(--spacing, 0.25rem) * 5);
  height: calc(var(--spacing, 0.25rem) * 5);
  -webkit-user-select: none;
  user-select: none;
}
.radio input {
  position: absolute;
  inset: 0px;
  opacity: 0%;
  appearance: none;
  cursor: pointer;
}
.radio input + span {
  display: block;
  position: absolute;
  inset: 0px;
}
.radio input:focus + span, .radio input:focus-visible + span {
  outline-width: 1px;
  outline-style: var(--tw-outline-style);
  outline-width: 2px;
  outline-color: var(--color-primary-500);
}
.radio input + span svg {
  position: absolute;
  inset: 0px;
  margin: auto;
  color: var(--color-emphasis-ultra, var(--color-primary-400));
}
.disabled {
  opacity: 30%;
}
@property --tw-outline-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-outline-style: solid;
    }
  }
}
